import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SWRConfig } from 'swr';

//
import App from './App';

const BUILD_ID = process.env.REACT_APP_BUILD_ID;

try {
  const storedBuild = localStorage.getItem('build-id');
  if (storedBuild && storedBuild !== BUILD_ID) {
    if (window.confirm('Nova versão disponível. Atualizar agora?')) {
      localStorage.setItem('build-id', BUILD_ID);
      window.location.reload(true);
    }
  } else {
    localStorage.setItem('build-id', BUILD_ID);
  }
} catch (e) {
  console.warn('Build check failed', e);
}
// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

const swrConfig = {
  revalidateOnFocus: true,
};

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <SWRConfig value={swrConfig}>
          <App />
        </SWRConfig>,
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
